import { render, staticRenderFns } from "./download.vue?vue&type=template&id=081da37a&scoped=true"
import script from "./download.vue?vue&type=script&lang=js"
export * from "./download.vue?vue&type=script&lang=js"
import style0 from "./download.vue?vue&type=style&index=0&id=081da37a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081da37a",
  null
  
)

export default component.exports